var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox"},[_c('input',{staticClass:"checkbox__input",attrs:{"type":"checkbox","checked":""},on:{"click":_vm.change}}),_c('span',{staticClass:"checkbox__box"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }